/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { notificationBatchControllerSearch } from '../fn/notification-batch/notification-batch-controller-search';
import { NotificationBatchControllerSearch$Params } from '../fn/notification-batch/notification-batch-controller-search';
import { NotificationBatchDto } from '../models/notification-batch-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class NotificationBatchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationBatchControllerSearch()` */
  static readonly NotificationBatchControllerSearchPath = '/api/notification-batch/search';

  /**
   * 알림 발송 내역 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationBatchControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationBatchControllerSearch$Response(params: NotificationBatchControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = notificationBatchControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 알림 발송 내역 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationBatchControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationBatchControllerSearch(params: NotificationBatchControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.notificationBatchControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

}
